import React, { Component } from 'react';
import axios from 'axios';
import { translate } from 'react-switch-lang';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { withRouter } from 'react-router';
// import logo from '../../../images/20070-2-small.png';
import logo from '../../../images/logoglobenew.png';
import LoginCard from '../../auth/components/LoginCard';
import LoginForm from '../../auth/components/LoginForm';
import TextInput from '../../components/forms/TextInput';
import StandardButton from '../../components/buttons/Base/StandardButton';
import { requestPost } from '../../services/real.backend';
import { API_CHANGE_PASSWORD } from '../../services/apiPoints';

class PasswordRestore extends Component {
  state = {
    newPassword: '',
  }

  savePassword = () => {
    const { t, history } = this.props;
    requestPost(API_CHANGE_PASSWORD, {
      code: this.props.match.params.code,
      newpass: this.state.newPassword,
    })
      .then((resp) => {
        if (resp.status == 'ok') {
          toast.success(t('auth.password change success'));
          history.push('/app');
        } else {
          toast.error(t(`auth.${resp.status}`));
        }
      })
      .catch((e) => console.log(e));
  }

  render() {
    const { t } = this.props;
    const { newPassword } = this.state;
    return (
      <div>
        <div className="page-wrapper">
          <div className="container-fluid p-0">
            {/* <!-- login page start--> */}
            <div className="authentication-main">
              <div className="row">
                <div className="col-md-12">
                  <div className="auth-innerright">
                    <div className="authentication-box">
                      <div className="text-center">
                        <img src={logo} alt="" className="box-logo" />
                      </div>
                      <div className="card mt-4">
                        <div className="card-body">
                          <div className="text-center">
                            <h4>{t('auth.Restore')}</h4>
                            <h6>
                              {t('auth.New Password')}
                            </h6>
                          </div>
                          <div>
                            <form>
                              <TextInput
                                placeholder={t('auth.Password')}
                                id="restore-password"
                                type="password"
                                value={newPassword}
                                onChange={(e) => this.setState({ newPassword: e.target.value })}
                              />
                              <StandardButton
                                onClick={this.savePassword}
                                id="change-password"
                              >
                                {t('auth.savePassword')}
                              </StandardButton>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <!-- login page end--> */}
          </div>
        </div>
      </div>
    );
  }
}

PasswordRestore.propTypes = {};

export default translate(withRouter(PasswordRestore));
